import { Box, Card, CardContent, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import useStyles from './styles';
import { useTheme } from '@material-ui/core/styles';

export default function Section({ enabled, logo, path, title }) {
  const classes = useStyles();
  const history = useHistory();
  const { palette } = useTheme();

  return (
    <Card
      onClick={path ? () => history.push(path) : () => {}}
      className={`${classes.root} ${path ? classes.hoverable : ''}`}
      variant="outlined"
    >
      <CardContent className={classes.container}>
        <Box className={classes.logoContainer}>
          <Box
            style={{
              backgroundColor: enabled ? palette.tertiary.main : palette.common.black,
              WebkitMaskSize: 'contain',
              maskPosition: 'center',
              WebkitMaskPosition: 'center',
              maskSize: 'contain',
              WebkitMaskRepeat: 'no-repeat',
              MaskRepeat: 'no-repeat',
              WebkitMaskImage: `url(${logo})`,
              maskImage: `url(${logo})`,
              width: '100%',
              height: '100%',
            }}
          />
        </Box>
        <Typography className={classes.title} style={{ color: enabled ? '' : palette.common.black }} variant="h4">
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
}
